
// Alphabet-wise
const uris = {
  companyDisclosureDetails: "/company/doc-source",
  companyHistory: "/company/history",
  companyInsights: "/company/insights",
  companyResearch: "/company/research",
  controDisclosureDetails: "/contro/doc-source",
  controHistory: "/contro/history",
  controInsights: "/contro/insights",
  controResearch: "/contro/research",
  createBatch: "/create-batch",
  customDisclosureDetails: "/custom/doc-source",
  customHistory: "/custom/history",
  customInsights: "/custom/insights",
  customPlaybookQuestion: "custom-playbook/question",
  customResearch: "/custom/research",
  editPlaybook: "/playbook/edit-playbook",
  entityList: "/entity-list",
  esgPlaybookRegulations: "/esg-playbook/regulations",
  esgPlaybookFrameworks: "/esg-playbook/frameworks",
  esgPlaybookScreeners: "/esg-playbook/screeners",
  fundHistory: "/fund/history",
  fundResearch: "/fund/research",
  geminiPromptEvaluation: "/custom/prompt-evaluation",
  investorDisclosureDetails: "/investor/doc-source",
  investorHistory: "/investor/history",
  investorInsights: "/investor/insights",
  investorResearch: "/investor/research",
  labsHistory: "/labs/history",
  labsModelEvaluation: "/labs/model-evaluation",
  labsPromptEvaluation: "/labs/prompt-evaluation",
  login: "/",
  manageEntity: "/entities/manageEntities",
  managePlaybook: "/playbook/manage-playbook",
  orgSettings: "/organization-settings",
  outputReview: "/review-output",
  viewMetrics: "/view-metrics",
  privateResearch: "/private-research",
  paymentSuccess: "/payment-success",
  paymentCancel: "/payment-cancel",
  playbookBatch: "/manage-batch",
  portfolio: "/settings/portfolio",
  privateResearch: "/private-research",
  realEstateDisclosureDetails: "/real-estate/doc-source",
  realEstateHistory: "/real-estate/history",
  realEstateInsights: "/real-estate/insights",
  realEstateResearch: "/real-estate/research",
  resetPassword: "/activate/:id",
  register: "/register",
  reviewEntities: "/review-entities",
  settings: "/settings",
  stripeCheckout: "/checkout",
  subscription: "/subscription",
  support: "/support",
  uploadEntities: "/entities/uploadEntities",
  viewQuestions: "/esg-playbook/questions/:id",
  viewReviewedCharts: "/view-reviewed-metrics"
};

export const externalLinks = {
  bookDemo: "https://calendly.com/rohit-kodancha/esgsure-introductory-call",
  esgSureContact: "https://www.esgsure.com/contact",
  esgSurePricing: "https://www.esgsure.com/pricing",
}


export default uris;
